<template>
<div>
  <section class="content">
    <div class="box info-box">
      <div class="box-header with-border">
        Filter By
      </div>
      <div class="box-body">
        <div class="row">
          <!-- <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
            <div class="form-group">
              <label for="Session">Session</label>
              <v-select v-model="filterSession" name="financial_year_id" label="name" :options="sessions" placeholder="Select Session" v-on:input="getSessionWiseRecord"></v-select>
              
              <has-error
                :form="form"
                field="financial_year_id"
              ></has-error>
            </div>
          </div> -->
          <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
            <label for="Branch">Branch</label>
            <v-select v-model="branchDetails" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord"></v-select>
            
            <has-error
              :form="form"
              field="branch_id"
            ></has-error>
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- Default box -->
    <div class="box box-info">
      <div class="box-header with-border">
        <h3 class="box-title">Latest Orders</h3>

        <div class="box-tools pull-right">
          <a :href="`${this.$axios.defaults.baseURL}/trialbalance/export/excel?startDate=${filter.startDate}&endDate=${filter.endDate}`" class="btn btn-box-tool"><i class="fa fa-file-excel-o"></i> Export
          </a>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
        <div class="table-responsive">
          <div class="row">
            <!-- <div class="col-md-3">
              <div class="form-group">
                <label for="branch_id">Branch:</label>
                <input type="text" v-model="filter.branch_id" class="form-control" id="branch_id">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="ledger_id">Ledger:</label>
                <input type="text" v-model="filter.ledger_id" class="form-control" id="ledger_id">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="startDate">Start Date:</label>
                <input type="date" v-model="filter.startDate" @change="changeFilter" class="form-control" id="startDate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="EndDate">End Date:</label>
                <input type="date" v-model="filter.endDate" @change="changeFilter" class="form-control" id="EndDate">
              </div>
            </div> -->
          </div>
            <table border="1" class="table table-striped table-bordered table-hover">
                <thead class="thead-dark">
                    <tr>
                        <th width="50%">PARTICULARS</th>
                        <th width="12%">OPENING</th>
                        <th width="13%">DEBIT</th>
                        <th width="13%">CREDIT</th>
                        <th widthwidth="12%">CLOSING</th>
                    </tr>
                </thead>
            </table>
            <table border="1" class="table table-striped table-bordered table-hover"  v-for="item in rows" :key="item.id">
                <tbody class="thead-light">
                    <tr>
                        <th width="50%" class="thead-dark">{{item.group}}</th>
                        <td width="12%">{{ openingAmountGP(item) }}</td>
                        <td width="13%" style="color:green;">{{ drAmountGP(item) }}</td>
                        <td width="13%" style="color:red;">{{ crAmountGP(item) }}</td>
                        <td width="12%">0</td>
                    </tr>
                    <tr v-for="ledger in item.ledgers" :key="ledger.id+'a'">
                        <td width="50%">{{ ledger.name }}</td>
                        <td width="12%">{{ openingAmount(ledger) }}</td>
                        <td width="13%" style="color:green;">{{ drAmount(ledger) }}</td>
                        <td width="13%" style="color:red;">{{ crAmount(ledger) }}</td>
                        <td width="12%">{{ closingAmount(ledger) }}</td>
                    </tr>
                </tbody>
            </table>
                
        </div>
        <!-- /.table-responsive -->
      </div>
    </div>
    <!-- /.box -->
  </section>
</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
export default {
  name: 'TrailBalance',
  data () {
    return {
      editMode: false,
      branchDetails: {},
      branchId: '',
      filter: {
        branch_id: null,
        ledger_id: null,
        startDate: null,
        endDate: null
      },
      form: new Form({
        id: '',
        name: '',
        shortName: '',
        status: ''
      }),
      // columns: [
      //   {
      //     label: 'NAME',
      //     field: 'name'
      //   },

      //   {
      //     label: 'SHORT NAME',
      //     field: 'shortName'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },

      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: [],
      row: {}
    }
  },
  mixins: [GetBranch],
  methods: {
    drAmount (ledger) {
      return _.sumBy(ledger.br_ledgers, function (o) { return o.dr_amt })
    },
    crAmount (ledger) {
      return _.sumBy(ledger.br_ledgers, function (o) { return o.cr_amt })
    },
    openingAmount (ledger) {
      return _.sumBy(ledger.br_ledgers, function (o) { return parseFloat(o.openingAmt) })
    },
    closingAmount (ledger) {
      return (_.sumBy(ledger.br_ledgers, function (o) { return parseFloat(o.openingAmt) }) + _.sumBy(ledger.br_ledgers, function (o) { return o.dr_amt })) - _.sumBy(ledger.br_ledgers, function (o) { return o.cr_amt })
    },

    drAmountGP (item) {
      var dd = 0
      _.forEach(item.ledgers, function (value, key) {
        dd += _.sumBy(value.br_ledgers, function (o) { return o.dr_amt })
      })
      return dd
    },
    crAmountGP (item) {
      var dd = 0
      _.forEach(item.ledgers, function (value, key) {
        dd += _.sumBy(value.br_ledgers, function (o) { return o.cr_amt })
      })
      return dd
    },
    openingAmountGP (item) {
      var dd = 0
      _.forEach(item.ledgers, function (value, key) {
        dd += _.sumBy(value.br_ledgers, function (o) { return parseFloat(o.openingAmt) })
      })
      return dd
    },
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    // newModal () {
    //   this.editMode = false
    //   this.form.reset()
    //   $('#newModal').modal('show')
    // },

    // editModal (row) {
    //   this.editMode = true
    //   this.form.reset()
    //   $('#newModal').modal('show')
    //   this.form.fill(row)
    // },
    // updateBank () {
    //   // console.log('update data')

    //   this.$axios
    //     .put('bank/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then(() => {
    //       Fire.$emit('AfterCreate')
    //       $('#newModal').modal('hide')
    //       Toast.fire({
    //         icon: 'success',
    //         title: 'Bank Details Updated Successfully'
    //       })
    //     })
    //     .catch(
    //       function (error) {
    //         Toast.fire({ icon: 'error', title: 'Please Try Again' })
    //         this.form.errors.errors = error.response.data.error
    //       }.bind(this)
    //     )
    // },
    getBranchWiseRecord () {
      this.branchId = this.branchDetails.id
      this.changeFilter()
    },
    changeFilter () {
      let loader = this.$loading.show()
      var pageUrl = 'trialbalance?'
      if (this.branchId) {
        pageUrl += `branch_id=${this.branchId}`
      }
      this.$axios
        .post(pageUrl, this.filter, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data
        })
        .catch(function (error) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error
          })
        })
    }
  },

  created () {
    this.getBranch()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>



// WEBPACK FOOTER //
// TrailBalance.vue?e32bdf72